// @flow
import { createStore } from 'redux';
import type { Store } from 'redux'; // eslint-disable-line no-duplicate-imports

import rootReducer from './reducers';
import inBrowser from './utils/inBrowser';
// eslint-disable-next-line no-duplicate-imports
import type { State, Action } from './reducers';

export default function configureStore(
  initialState?: State
): Store<State, Action<*>> {
  if (inBrowser() && process.env.NODE_ENV === 'development') {
    /* eslint-disable no-underscore-dangle */
    return createStore(
      rootReducer,
      initialState,
      window.__REDUX_DEVTOOLS_EXTENSION__
      && window.__REDUX_DEVTOOLS_EXTENSION__()
    );
  }

  return createStore(rootReducer, initialState);
}



// WEBPACK FOOTER //
// ./src/configureStore.js